<template>
  <el-select
    v-model="dataValue"
    style="width: 200px;"
    placeholder="请选择服务产品">
    <el-option
      v-for="item in list"
      :key="item.serviceId"
      :label="item.serviceName"
      :value="item.serviceId"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'ServiceSelect',
  props: ['value', 'callback'],
  data() {
    return {
      list: []
    }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dataValue() {
      this.onChage()
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onChage() {
      this.$nextTick(() => {
        const row = this.list.find(i => i.serviceId === this.dataValue)
        console.log('````````````````````````````onChage', row)
        row && this.callback && this.callback(row)
      })
    },
    getList() {
      this.$store.dispatch('account/getservices', {
        payload: {},
        success: (res) => {
          this.list = res.data.records
          console.log('````````````````````````````dataValue', this.dataValue)
          if (this.dataValue) {
            this.onChage()
          }
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" type="text/stylus" scoped></style>
